import Feature32 from './Feature32'
export default Feature32
